<template>
  <div>
    <HeaderComponent />
    <main class="bg-gray-50 py-12">
    <div class="container mx-auto px-4">

      <!-- Loading indicator for the heading -->
     <div v-if="isLoading" class="h-10 bg-gray-300 animate-pulse rounded mb-8"></div>
      <h1 v-else class="text-4xl font-semibold text-center mb-8">Blog Posts</h1>

      <!-- Loading indicator for posts -->
      <div v-if="isLoading" class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div v-for="i in 6" :key="i" class="bg-gray-200 animate-pulse rounded-lg overflow-hidden">
          <div class="h-48 bg-gray-300"></div>
          <div class="p-8">
            <div class="h-6 bg-gray-300 rounded mb-4"></div>
            <div class="h-48 w-full bg-gray-300 rounded mb-6"></div>
            <div class="h-6 w-1/3 bg-gray-300 rounded mb-12"></div>
            <div class="h-6 w-full bg-gray-300 rounded"></div>
          </div>
        </div>
      </div>

      <!-- Use PostsGrid component -->
      <PostsGrid
        v-else
        :posts="posts"
        :currentPage="currentPage"
        :totalPages="totalPages"
        :isPaginationShow="showPagination"
        :isCategoryShow="showCategory"
        :postType="currentPost"
      />

    </div>
  </main>
    <FooterComponent />
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import {useCommonHead} from '../composables/useCommonHead';
import HeaderComponent from "../components/Header.vue";
import FooterComponent from "../components/Footer.vue";
import { getPaginatedPosts } from '@/api/wordpress';
import PostsGrid from "../components/PostsGrid.vue";

const route = useRoute();

const posts = ref([]);
const currentPage = ref(1);
const totalPages = ref(1);
const isLoading = ref(true);
const showPagination = ref(true);
const showCategory = ref(true);
const currentPost = ref('Blog'); 

let pageTitle = 'Blog - Arrify';
let currentUrl = 'https://arrify.com/blog';
let pageDescription = 'Explore the latest blog posts from Arrify on various topics related to Salesforce development and best practices.';

const fetchPosts = async (page) => {
  isLoading.value = true;
  try {
    const response = await getPaginatedPosts(page);
    console.log('posts');
    console.log(response);
    posts.value = response.posts;
    totalPages.value = response.total_pages;
    currentPage.value = page;  
  } catch (error) {
    console.error('Failed to fetch blog posts:', error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  const page = parseInt(route.params.page) || 1;
  fetchPosts(page);
});

watch(() => route.params.page, (newPage) => {
  const page = parseInt(newPage) || 1;
  fetchPosts(page);
});

// Compute the next page URL
const nextPageUrl = computed(() => {
  if (currentPage.value < totalPages.value) {
    return `https://arrify.com/blog/page/${currentPage.value + 1}/`;
  }
  return null;
});

useCommonHead(pageTitle, pageDescription, currentUrl, nextPageUrl);

</script>

<style scoped>
/* Optional styles for loading animation */
.animate-pulse {
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0%, 100% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #f0f0f0;
  }
}
</style>